import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import OrderForm from "./OrderForm";
import API from "../../api"; // Your API instance
import CustomTable from "../../components/Table/CustomTable";
import ConfirmationModal from "../../components/ConfirmationModal";

export default function Order() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({ currentPage: 1, pageSize: 5 });

  const getOrders = async () => {
    try {
      const response = await API.get("/orders");

      setOrders(response?.data);
    } catch (err) {
      console.error("Error fetching orders:", err);
      message.error("Failed to load orders.");
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  const handleSaveOrder = async (updatedOrder) => {
    try {
      if (selectedOrder) {
        const response = await API.put(
          `/orders/${selectedOrder?._id}`,
          updatedOrder
        );
        if (response.status === 200) {
          message.success("Order updated successfully!");
          setOrders((prev) =>
            prev.map((order) =>
              order._id === selectedOrder?._id
                ? { ...order, ...updatedOrder }
                : order
            )
          );
        }
      } else {
        const response = await API.post("/orders", updatedOrder);
        if (response.status === 201) {
          message.success("Order created successfully!");
          setOrders((prev) => [response?.data, ...prev]);
        }
      }
    } catch (error) {
      console.error("Error saving order:", error);
      message.error(error.response?.data?.message);
    } finally {
      setOpenDrawer(false);
    }
  };

  const handleEditOrder = (order) => {
    setSelectedOrder(order);
    setOpenDrawer(true);
  };

  const handleDeleteOrder = async () => {
    try {
      await API.delete(`/orders/${orderToDelete}`);
      message.success("Order deleted successfully!");
      setOrders((prev) => prev.filter((order) => order?._id !== orderToDelete));
      setIsDeleteModalVisible(false);
    } catch (error) {
      message.error(error.response?.data?.message);
    }
  };

  const columns = [
    {
      title: "Index",
      key: "index",
      render: (_, __, index) =>
        (paginationInfo.currentPage - 1) * paginationInfo.pageSize + index + 1,
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
    },
    {
      title: "Branch Name",
      render: (_, order) => order?.storeId?.name, // Display store name
      key: "storeName",
    },
    // {
    //   title: "Branch Address",
    //   render: (_, order) => order.storeId.address, // Display store address
    //   key: "storeAddress",
    // },
    {
      title: "Branch Phone",
      render: (_, order) => order?.storeId?.phone, // Display store phone
      key: "storePhone",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
    {
      title: "Products",
      render: (_, order) => (
        <ul aria-atomic>
          {order.products.map((product) => (
            <li key={product?._id}>
              {product?.productId?.name} (Qty: {product?.quantity}, Total:{" "}
              {product?.totalPrice})
            </li>
          ))}
        </ul>
      ),
      key: "products",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, order) => (
        <div>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEditOrder(order)}
            style={{ marginRight: "8px" }}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={() => {
              setOrderToDelete(order._id);
              setIsDeleteModalVisible(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => {
          setSelectedOrder(null);
          setOpenDrawer(true);
        }}
        style={{ marginBottom: 16 }}
      >
        Add Order
      </Button>

      <CustomTable columns={columns} dataSource={orders} onPaginationChange={(pagination) =>
          setPaginationInfo({ currentPage: pagination.current, pageSize: pagination.pageSize })
      }/>

      <OrderForm
        open={openDrawer}
        setOpen={setOpenDrawer}
        data={selectedOrder}
        onSave={handleSaveOrder}
      />

      <ConfirmationModal
        visible={isDeleteModalVisible}
        onConfirm={handleDeleteOrder}
        onCancel={() => setIsDeleteModalVisible(false)}
        message="Are you sure you want to delete this order?"
      />
    </div>
  );
}
